// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","flashMessage":"_1vvLIomPU8Fym50R9oHq7M"};